var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { staticClass: "primary", attrs: { column: "" } },
    [
      _c("v-parallax", {
        attrs: {
          src: "https://gm.goz.fun/wp-content/uploads/2023/03/about-cover.jpg",
          height: "400",
          role: "img",
          "aria-label": "Artwork banner for the About page",
        },
      }),
      _vm._v(" "),
      _c(
        "v-container",
        [
          _c(
            "v-card",
            [
              _c(
                "v-app-bar",
                {
                  staticClass: "font-weight-thin text-uppercase",
                  attrs: {
                    flat: "",
                    color: "primary",
                    role: "heading",
                    "aria-level": "2",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("components.about.whoWeAre.title")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("components.about.whoWeAre.description")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-app-bar",
                {
                  staticClass: "font-weight-thin text-uppercase",
                  attrs: {
                    flat: "",
                    color: "primary",
                    role: "heading",
                    "aria-level": "2",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("components.about.whatWeDo.title")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("components.about.whatWeDo.description")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-app-bar",
                {
                  staticClass: "font-weight-thin text-uppercase",
                  attrs: {
                    flat: "",
                    color: "primary",
                    role: "heading",
                    "aria-level": "2",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("components.about.founder.title")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("components.about.founder.description.0")) +
                      "\n        "
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        elevation: "0",
                        "x-small": "",
                        color: "transparent",
                        target: "_blank",
                        href: _vm.communities.founderGoku,
                        "aria-label": "Open founder profile in new tab",
                        role: "link",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("components.about.founder.boldStatement")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("components.about.founder.description.1")) +
                      "\n      "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-app-bar",
                {
                  staticClass: "font-weight-thin text-uppercase",
                  attrs: {
                    flat: "",
                    color: "primary",
                    role: "heading",
                    "aria-level": "2",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("components.about.projects.amw.title")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("components.about.projects.amw.description.0")
                      ) +
                      "\n        "
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        elevation: "0",
                        "x-small": "",
                        color: "transparent",
                        target: "_blank",
                        href: _vm.communities.amwPage,
                        "aria-label": "Visit AMW website (opens new tab)",
                        role: "link",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "components.about.projects.amw.boldStatement"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("components.about.projects.amw.description.1")
                      ) +
                      "\n      "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-app-bar",
                {
                  staticClass: "font-weight-thin text-uppercase",
                  attrs: {
                    flat: "",
                    color: "primary",
                    role: "heading",
                    "aria-level": "2",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("components.about.projects.amw.foundedTitle")
                      ) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("components.about.projects.amw.description.0")
                      ) +
                      "\n        "
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        elevation: "0",
                        "x-small": "",
                        color: "transparent",
                        target: "_blank",
                        href: _vm.communities.amwCompanyPage,
                        "aria-label": "Open AMW company profile (new tab)",
                        role: "link",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "components.about.projects.amw.foundedBoldStatement"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("components.about.projects.amw.description.1")
                      ) +
                      "\n      "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-app-bar",
                {
                  staticClass: "font-weight-thin text-uppercase",
                  attrs: {
                    flat: "",
                    color: "primary",
                    role: "heading",
                    "aria-level": "2",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("components.about.founder.countryTitle")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("components.about.founder.countryName")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-app-bar",
                {
                  staticClass: "font-weight-thin text-uppercase",
                  attrs: {
                    flat: "",
                    color: "primary",
                    role: "heading",
                    "aria-level": "2",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("components.about.projects.gozgame.title")
                      ) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "components.about.projects.gozgame.description.0"
                        )
                      ) +
                      "\n        "
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        elevation: "0",
                        "x-small": "",
                        color: "transparent",
                        target: "_blank",
                        href: _vm.goodsStore,
                        "aria-label": "Open Gods of Zushin Store (new tab)",
                        role: "link",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "components.about.projects.gozgame.boldStatement"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "components.about.projects.gozgame.description.1"
                        )
                      ) +
                      "\n      "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-app-bar",
                {
                  staticClass: "font-weight-thin text-uppercase",
                  attrs: {
                    flat: "",
                    color: "primary",
                    role: "heading",
                    "aria-level": "2",
                  },
                },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("components.about.projects.goz.title")) +
                        "\n        "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c("v-progress-linear", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isLoading,
                expression: "isLoading",
              },
            ],
            attrs: {
              color: "accent",
              indeterminate: "",
              role: "status",
              "aria-label": "Loading timeline",
            },
          }),
          _vm._v(" "),
          _c(
            "v-timeline",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isLoading,
                  expression: "!isLoading",
                },
              ],
              attrs: {
                "aria-label": "Company achievements timeline",
                role: "list",
              },
            },
            _vm._l(_vm.timeline, function (achievement, i) {
              return _c(
                "v-timeline-item",
                {
                  key: i,
                  attrs: {
                    color: achievement.color,
                    small: "",
                    role: "listitem",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "opposite",
                        fn: function () {
                          return [
                            _c("span", {
                              class:
                                "headline font-weight-bold " +
                                achievement.color +
                                "--text",
                              domProps: {
                                textContent: _vm._s(achievement.date),
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _vm._v(" "),
                  _c("div", { staticClass: "py-4" }, [
                    _c(
                      "h3",
                      {
                        class:
                          "headline font-weight-light mb-4 " +
                          achievement.titleColor +
                          "--text lighten-1",
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(achievement.title) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(achievement.description))]),
                  ]),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c(
                "v-app-bar",
                {
                  staticClass: "font-weight-thin text-uppercase",
                  attrs: {
                    flat: "",
                    color: "primary",
                    role: "heading",
                    "aria-level": "2",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("components.about.projects.join.title")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _c("span", { staticClass: "font-weight-thin" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t("components.about.projects.join.description", {
                          email: _vm.email,
                        })
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c(
                "v-app-bar",
                {
                  staticClass: "font-weight-thin text-uppercase",
                  attrs: {
                    flat: "",
                    color: "primary",
                    role: "heading",
                    "aria-level": "2",
                  },
                },
                [
                  _c(
                    "v-toolbar-title",
                    { staticClass: "font-weight-thin text-body-2" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("components.about.projects.others.title")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-progress-linear", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isLoading,
                        expression: "isLoading",
                      },
                    ],
                    attrs: {
                      color: "accent",
                      indeterminate: "",
                      role: "status",
                      "aria-label": "Loading project list",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { wrap: "" } },
            _vm._l(_vm.projects, function (project) {
              var _obj
              return _c(
                "v-flex",
                _vm._b(
                  { key: project.id, attrs: { "full-width": "" } },
                  "v-flex",
                  ((_obj = {}),
                  (_obj[
                    "xs" +
                      project.flexExtraSmall +
                      " sm" +
                      project.flexSmall +
                      " md" +
                      project.flexMedium +
                      " lg" +
                      project.flexLarge
                  ] = true),
                  _obj),
                  false
                ),
                [
                  project.isActive
                    ? _c(
                        "v-card",
                        {
                          attrs: {
                            color: "secondary",
                            "full-width": "",
                            "aria-labelledby": "project-title-" + project.id,
                          },
                        },
                        [
                          _c("v-img", {
                            attrs: {
                              src: project.img,
                              alt: project.title,
                              height: "100px",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "v-card-title",
                            { attrs: { "primary-title": "" } },
                            [
                              _c("div", [
                                _c(
                                  "h4",
                                  {
                                    staticClass: "h5",
                                    attrs: {
                                      id: "project-title-" + project.id,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(project.title) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "grey--text text-subtitle-2" },
                                  [_vm._v(_vm._s(project.subtitle))]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    text: "",
                                    color: "accent",
                                    "aria-label":
                                      "Open project {{ project.title }} in a new tab",
                                    role: "link",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.viewProjectCard(project.link)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("common.view") || "View") +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    color: _vm.isCardVisible(project.id)
                                      ? "accent"
                                      : "",
                                    role: "button",
                                    "aria-label": _vm.isCardVisible(project.id)
                                      ? "Collapse details of " + project.title
                                      : "Expand details of " + project.title,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleProjectCard(project.id)
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.isCardVisible(project.id)
                                            ? "keyboard_arrow_down"
                                            : "keyboard_arrow_up"
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-slide-y-transition",
                            [
                              _c(
                                "v-card-text",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isCardVisible(project.id),
                                      expression: "isCardVisible(project.id)",
                                    },
                                  ],
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(project.brief) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }